<div
    [ngClass]="{
        'facebook-width':
            commonDataService.customerSettings.isFacebookTicketWidthEnabled &&
            ticket.source === ticketSourceEnum.facebook,
    }">
    @if (!commonDataService.user.isReadOnly && ticket.isReviewNeeded && ticket.isEditable) {
        <div class="ticket-block review-block buttons-panel">
            <button class="btn" (click)="review(false)" translate>Hide</button>
            <button class="btn btn-primary" (click)="review(true)" translate>Add to timeline</button>
        </div>
    }

    <div class="ticket-block position-relative" [ngClass]="{ 'with-review': ticket.isReviewNeeded }">
        <app-ticket-main-message [ticket]="ticket"></app-ticket-main-message>

        <div class="thread-info d-flex justify-content-between mt-2" style="margin-bottom: -10px">
            @if (ticket.reactions?.length && parent.isFacebook) {
                <app-reactions
                    (click)="ticket.constraints.areReactionsAllowed && openReactionsWindow({ isTicketReactions: true })"
                    [class.pointer]="ticket.constraints.areReactionsAllowed"
                    [reactions]="ticket.reactions"
                    [isShowTotalCount]="true"
                    [tooltipTextType]="reactionTooltipTextType.name"
                    [updateReactionsMarker]="updateReactionsMarker">
                </app-reactions>
            }

            <span class="d-flex"></span>
            <span>
                <small class="text-light me-3">
                    {{ ticket.replyCount }}
                    @if (ticket.replyCount === 1) {
                        {{ 'comment' | translate }}
                    } @else {
                        {{ 'comments' | translate }}
                    }
                </small>

                @if (ticket.badWordsRate > 0) {
                    <small class="text-danger">
                        {{ ticket.badWordsRate }}% {{ 'of the replies contain bad words' | translate }}
                    </small>
                }

                @if (ticket.constraints.isDirectMessageForFbPostAllowed && ticket.privateReplyTicketId) {
                    <small class="text-light" translate> Ticket responded privately </small>
                }
            </span>
        </div>

        <div class="clearfix"></div>
        <hr />
        <div class="d-flex flex-row justify-content-between align-items-center likes-panel">
            @if (parent.isFacebook || ticket.constraints.isLikingAllowed) {
                <div class="text-md flex-grow-1">
                    <span
                        tooltip="{{
                            ticket.isTicketCanBeReplied && ticket.constraints.isLikingAllowed
                                ? ''
                                : ('You can\'t like this ticket' | translate)
                        }}">
                        <button
                            class="btn btn-flat"
                            (click)="ticket.isTicketCanBeReplied && ticket.constraints.isLikingAllowed && toggleLike()"
                            [disabled]="
                                !(ticket.isTicketCanBeReplied && ticket.constraints.isLikingAllowed) ||
                                isUpdatingLikeStatus
                            ">
                            @if (parent.isFacebook) {
                                <sb-inline-svg
                                    class="icon icon-heart"
                                    [ngClass]="{ 'icon-liked-facebook': ticket.hasReactionFromTeam }"
                                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Thumbs up icon.svg'">
                                </sb-inline-svg>
                            } @else {
                                <sb-inline-svg
                                    class="icon icon-heart"
                                    [ngClass]="{ 'icon-liked': ticket.isLiked }"
                                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Heart icon.svg'">
                                </sb-inline-svg>
                                {{ ticket.likeCount || '' }}
                            }
                            {{ 'Like' | translate }}
                        </button>
                    </span>
                </div>
            }

            <div class="flex-grow-1">
                <span tooltip="{{ ticket.isTicketCanBeReplied ? '' : ('You can\'t comment this ticket' | translate) }}">
                    <button
                        class="btn btn-flat"
                        [disabled]="!ticket.isTicketCanBeReplied"
                        (click)="ticket.isTicketCanBeReplied && parent.showFullReplyForm()">
                        <sb-inline-svg
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Forward icon.svg'"
                            class="icon icon-flipped">
                        </sb-inline-svg>
                        <span translate> Comment </span>
                    </button>
                </span>
            </div>

            @if (!commonDataService.user.isReadOnly && ticket.source === ticketSourceEnum.facebook) {
                <div
                    class="flex-grow-1"
                    tooltip="{{ ticket.privateReplyTicketId ? ('Click to see response' | translate) : '' }}">
                    <span
                        tooltip="{{
                            ticket.constraints.isDirectMessageForFbPostAllowed
                                ? ''
                                : ('You can\'t send a message to such type of ticket or client message older than 7 days'
                                  | translate)
                        }}">
                        <button
                            class="btn btn-flat"
                            (click)="
                                ticket.constraints.isDirectMessageForFbPostAllowed &&
                                    (ticket.privateReplyTicketId
                                        ? openTicketInNewWindowService.openTicketInNewTab(ticket.privateReplyTicketId)
                                        : parent.openNewPrivateReplyForm(null))
                            "
                            [disabled]="!ticket.constraints.isDirectMessageForFbPostAllowed">
                            <sb-inline-svg class="icon" [url]="'/assets/images/chat-bobble.svg'"></sb-inline-svg>
                            <span translate> Message </span>
                        </button>
                    </span>
                </div>
            }

            @if (isAnsweringFromAnotherPage) {
                <div class="btn-group" dropdown>
                    <button
                        id="user-avatar-button"
                        type="button"
                        class="dropdown-toggle select-container ms-2 btn btn-transparent"
                        dropdownToggle
                        aria-controls="users-list-dropdown">
                        <sb-user-avatar
                            class="user-avatar-btn sort-name"
                            [size]="'btn'"
                            [user]="socialMediaSource"
                            [isNeedTooltip]="false">
                        </sb-user-avatar>
                    </button>

                    <ul
                        id="users-list-dropdown"
                        *dropdownMenu
                        class="dropdown-menu dropdown-menu-right"
                        role="menu"
                        aria-labelledby="user-avatar-button">
                        @for (account of socialMediaAccounts; track account) {
                            <li (click)="setSocialMediaSource(account.id)" role="menuitem">
                                <button class="dropdown-item pointer d-flex truncate">
                                    <sb-user-avatar
                                        class="user-avatar-btn"
                                        [size]="'btn'"
                                        [user]="account"
                                        [isNeedTooltip]="false">
                                    </sb-user-avatar>
                                    <span class="tag-text truncate">{{ account.name }}</span>
                                </button>
                            </li>
                        }
                    </ul>
                </div>
            }
        </div>
        <hr />
        <app-thread-sort-control (changeMessageOrder)="replySortingService.changeMessageOrder(true)">
        </app-thread-sort-control>

        <div class="mb-4">
            @if (
                !threadFilterService.hasVisibleReplies &&
                (threadFilterService.activeThreadFilter || threadFilterService.searchQuery?.length)
            ) {
                <div translate class="mt-1 print-hidden">There are no messages matching this filter.</div>
            }
        </div>

        @if (
            !(threadFilterService.searchQuery?.length > 2 || threadFilterService.activeThreadFilter) &&
            replySortingService.replySortBy === parent.messagesOrderEnum.creationTimeAsc
        ) {
            <app-thread-expander class="print-hidden" [parent]="parent" [ticket]="ticket"></app-thread-expander>
        }

        @for (
            reply of ticket.messageThread
                | filterReplies
                    : threadFilterService.collapseOptions
                    : replySortingService.replySortBy
                    : threadFilterService.searchQuery
                    : threadFilterService.activeThreadFilter
                    : ticket.messageThread.length
                    : threadFilterService.updateStamp
                    : undefined
                    : false
                    : noteService.referencedReply;
            track reply
        ) {
            @if (!reply.isRemovedByFilter || reply.isTransparent) {
                <!--
                    Auth thread messages should only be visible for chat tickets.
                    @if (reply.type === messageThreadElementTypeEnum.sessionAuthentication) {
                        <app-session-authentication-event
                            class="print-hidden"
                            [event]="reply"></app-session-authentication-event>
                    }
                -->
                @if (reply.type !== messageThreadElementTypeEnum.sessionAuthentication) {
                    <app-reply-social-media
                        class="ticket-message reply print-hidden"
                        [ngClass]="{
                            'not-viewed': reply.isViewed === false,
                            'reply-invalid': reply.isInvalid,
                            selected: reply.isSelected,
                        }"
                        [reply]="reply"
                        [ticket]="ticket"
                        [isSubReply]="false"
                        (openReactionsWindow)="openReactionsWindow($event)"
                        [level]="1">
                    </app-reply-social-media>
                }
            }
        }

        @if (threadFilterService.isPrinting) {
            <div style="display: none" class="ticket-thread-for-printing">
                @for (
                    reply of threadFilterService.messageThreadForPrinting
                        | filterReplies
                            : threadFilterService.collapseOptions
                            : replySortingService.replySortBy
                            : threadFilterService.searchQuery
                            : threadFilterService.activeThreadFilter
                            : ticket.messageThread.length
                            : threadFilterService.updateStamp
                            : undefined
                            : true
                            : undefined;
                    track reply
                ) {
                    @if (!reply.isRemovedByFilter || reply.isTransparent) {
                        <!--
                            Auth thread messages should only be visible for chat tickets.
                            @if (reply.type === messageThreadElementTypeEnum.sessionAuthentication) {
                                <app-session-authentication-event [event]="reply"></app-session-authentication-event>
                            }
                        -->
                        @if (reply.type !== messageThreadElementTypeEnum.sessionAuthentication) {
                            <app-reply-social-media
                                class="ticket-message reply"
                                [ngClass]="{
                                    'not-viewed': reply.isViewed === false,
                                    transparent: reply.isHidden,
                                    'reply-invalid': reply.isInvalid,
                                }"
                                [reply]="reply"
                                [ticket]="ticket"
                                [isSubReply]="false"
                                [level]="1">
                            </app-reply-social-media>
                        }
                    }
                }
            </div>
        }

        @if (
            !(threadFilterService.searchQuery?.length > 2 || threadFilterService.activeThreadFilter) &&
            replySortingService.replySortBy !== parent.messagesOrderEnum.creationTimeAsc
        ) {
            <app-thread-expander class="print-hidden" [parent]="parent" [ticket]="ticket"></app-thread-expander>
        }

        @if (ticket.isTicketCanBeReplied && ticket.suggestions.length) {
            <app-suggestions [suggestions]="ticket.suggestions"></app-suggestions>
        }
        @if (ticket.isTicketCanBeReplied) {
            <div class="expanded print-hidden">
                <div class="full-width new-reply unread-message ticket-message flex-row d-flex">
                    @if (parent.isSendingReply) {
                        <div class="ticket-blocker"></div>
                    }

                    <sb-user-avatar
                        class="user-avatar-sm"
                        [size]="'small'"
                        [user]="isAnsweringFromAnotherPage ? socialMediaSource : commonDataService.user"
                        [isNeedTooltip]="false">
                    </sb-user-avatar>

                    <div class="d-flex flex-column" style="width: 100%">
                        <app-new-reply-social-media [ticket]="ticket" [parent]="parent" [newReply]="parent.newReply">
                        </app-new-reply-social-media>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
